export const text = {
  title: 'General Settings',
  projectNameForFront: 'Project Name For Admin/Front',
  projectNameForFrontTipText:
    'This will appear as a Project name at all places like front and admin panel',
  enterProjectNameForFront: 'Enter project name for admin/front',
  defaultDistanceUnit: 'Default Distance Unit',
  defaultDistanceUnitTipText: 'Admin country distance unit',
  lineItemValue: 'T&M Line Items Value',
  companyDefaultHourlyRate: 'Company Default Hourly Rate (In USD)',
  companyDefaultHourlyRateTipText:
    'Default labor rate per hour for T&M jobs if provider rate is not set',
  enterCompanyDefaultHourlyRate: 'Enter company default hourly rate',
  materialMarkupPercentage: 'Material Markup Percentage',
  materialMarkupPercentageTipText:
    'Markup percentage applied to material cost (e.g. 112 = 1.12x)',
  enterMaterialMarkupPercentage: 'Enter material markup percentage',
  selectDefaultDistanceUnit: 'Select default distance unit',
  adminCountryISDCode: 'Admin Country ISD Code',
  adminCountryISDCodeTipText:
    'This code will be used for calling and sending SMS from application.',
  enterAdminCountryISDCode: 'Enter admin country ISD code',
  displayRecordPerPageInAdminPanel: 'Display Record Per Page In Admin Panel',
  displayRecordPerPageInAdminPanelTipText:
    'Number of records to display per page in admin panel',
  enterDisplayRecord: 'Enter display record per page in admin panel',
  countryCodeTipText:
    'Country selected here will appear as selected by default at all the forms for the website/applications.',
  noteGeneralSetting:
    'Please close the application and open it again to see the settings reflected after saving the new setting values above.',
};
